// extracted by mini-css-extract-plugin
module.exports = {"reaction":"dece2e673c--reaction--aag2f","like":"dece2e673c--like--FWXZN","dislike":"dece2e673c--dislike--LKmE5"};